exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-container-2j4fx{padding:0 6px;width:fit-content;margin:auto;background-color:var(--bg);color:var(--color);text-align:center;font-size:12px;font-weight:500;line-height:16px;border-radius:28px;letter-spacing:.12px}.style-cssmodule-container-2j4fx[data-type=info]{--bg:var(--color-blue-lighter);--color:var(--color-blue-normal)}.style-cssmodule-container-2j4fx[data-type=success]{--bg:var(--color-green-lighter);--color:var(--color-green-middle-2)}.style-cssmodule-container-2j4fx[data-type=warning]{--bg:var(--color-orange-lighter);--color:var(--color-orange-middle)}.style-cssmodule-container-2j4fx[data-type=waiting]{--bg:var(--color-sky-gray2);--color:var(--color-blue-gray-dark)}.style-cssmodule-container-2j4fx[data-type=refunded]{--bg:var(--color-blue-lighter);--color:var(--color-blue-normal)}", ""]);

// exports
exports.locals = {
	"container": "style-cssmodule-container-2j4fx"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/Payment/components/Badge/style.cssmodule.css
// module id = 2561
// module chunks = 121